import React from 'react';
import { LockIcon, ZapIcon, ShieldCheckIcon, CheckIcon } from 'lucide-react';
import { CtaButton } from './CtaButton';

/** TODO: replace with the live checkout URL (sales platform not defined yet). */
const CHECKOUT_URL = 'https://wrestling-practice-ready.impultienda.ar/checkout';
const included = ['6 volumes · 90 practices planned', '5 instant-use bonuses', '300 landscape pages, print or phone', '90, 75 and 60-minute clocks for every practice', '24 planning worksheets', 'Lifetime access to your files'];
export function Pricing() {
  return <section id="pricing" aria-labelledby="pricing-heading" className="w-full bg-blush text-ink" data-id="element-180" data-mp="1rut0lnpo1w1k">
      <div className="max-w-2xl mx-auto px-5 py-16 sm:py-20" data-id="element-181" data-mp="20tefn8vxisxl">
        <div className="text-center" data-id="element-182" data-mp="20v7p0vxxfr9a">
          <p className="text-[11px] font-semibold uppercase tracking-[1.8px] text-gold-deep" data-id="element-183" data-mp="3h6v6ztr0l6jh">
            Complete package
          </p>
          <h2 id="pricing-heading" className="mt-3 font-display font-semibold text-plum text-3xl sm:text-5xl" data-id="element-184" data-mp="3c7ibylpzot5t">
            Everything you need to run the{' '}
            <span className="text-gold-deep" data-id="element-185" data-mp="4ruh7bchny6e">next 90 practices</span>
          </h2>
        </div>

        <div className="mt-8 overflow-hidden rounded-3xl border border-blush-dark bg-white shadow-card" data-id="element-186" data-mp="9tjwx4anp00t">
          <div className="bg-plum px-5 py-5 text-center" data-id="element-187" data-mp="eq0grmatos83">
            <h3 className="font-display text-xl font-semibold text-white sm:text-2xl" data-id="element-188" data-mp="3d97d7eknjgo6">
              Wrestling Practice Ready — The Complete Season Megapack
            </h3>
            <p className="mt-1 text-[13px] font-semibold text-gold-hover" data-id="element-189" data-mp="3i5pgea0c36ye">
              6 Volumes + 5 Bonuses
            </p>
          </div>

          <div className="p-5 sm:p-7" data-id="element-190" data-mp="3ry3p5mptxdu2">
            <img src="https://cdn.magicpatterns.com/uploads/mhN9KYKgvLcn6dXCYqdq7k/DPS26-mockup-cuadernillos-3x2.png" alt="The six Wrestling Practice Ready volumes laid out on a coach's table beside a wrestling mat" width={2048} height={1360} loading="lazy" className="mx-auto w-full max-w-2xl rounded-xl object-cover shadow-card" data-id="element-191" data-mp="3rz6f9sfbvc8x" />

            <ul className="mt-6 grid gap-2.5 sm:grid-cols-2" data-id="element-192" data-mp="316ekop8yo0b8">
              {included.map(item => <li key={item} className="flex items-start gap-2 text-sm" data-id="element-193" data-mp="2w7uzir26ysjx">
                  <span className="mt-0.5 flex h-[18px] w-[18px] flex-none items-center justify-center rounded-full bg-gold/20" data-id="element-194" data-mp="2w9xl8ywb9ziu">
                    <CheckIcon className="h-3 w-3 text-gold-deep" aria-hidden="true" data-id="element-195" data-mp="23jfijyzi205y" />
                  </span>
                  {item}
                </li>)}
            </ul>

            <div className="mt-7 border-t border-cream-dark pt-6 text-center" data-id="element-196" data-mp="2dfsfd5qccu4x">
              <div className="mt-1 flex items-start justify-center gap-1 text-plum" data-id="element-197" data-mp="3tu0qm45nvh19">
                <span className="mt-2.5 font-display text-3xl" data-id="element-198" data-mp="3ov7ae3yzpbxe">$</span>
                <span className="font-display font-semibold text-6xl leading-[0.9] sm:text-7xl" data-id="element-199" data-mp="aneup3bsktz">
                  27
                </span>
                <span className="mt-3 text-[13px] font-semibold text-ink-muted" data-id="element-200" data-mp="5b1lq3t6xoqf">
                  USD
                </span>
              </div>

              <div className="mt-3 flex flex-wrap justify-center gap-2" data-id="element-201" data-mp="3rgot16il7uju">
                <span className="rounded-full border border-cream-dark px-3 py-1 text-[10px] font-semibold uppercase tracking-widest text-ink-soft" data-id="element-202" data-mp="3rirfjgkj75jt">
                  One-time payment
                </span>
                <span className="rounded-full border border-cream-dark px-3 py-1 text-[10px] font-semibold uppercase tracking-widest text-ink-soft" data-id="element-203" data-mp="o1sqst65asz0">
                  No subscription
                </span>
              </div>

              <CtaButton href={CHECKOUT_URL} className="mt-5" data-id="element-204" data-mp="11zzg3kx13kn2">
                Get Wrestling Practice Ready — only $27
              </CtaButton>

              <p className="mt-3 text-xs text-ink-muted" data-id="element-205" data-mp="16s0notj94n6r">
                Backed by the 7-day money-back guarantee
              </p>

              <ul className="mt-4 flex flex-wrap justify-center gap-x-5 gap-y-2 text-xs font-medium text-ink-soft" data-id="element-206" data-mp="3f55wdcx2eq2j">
                <li className="flex items-center gap-1.5" data-id="element-207" data-mp="3592qbvz3e7ab">
                  <LockIcon className="h-4 w-4 text-gold-deep" aria-hidden="true" data-id="element-208" data-mp="359m89coqsvoc" />
                  Secure checkout
                </li>
                <li className="flex items-center gap-1.5" data-id="element-209" data-mp="1rublkznvnjt">
                  <ZapIcon className="h-4 w-4 text-gold-deep" aria-hidden="true" data-id="element-210" data-mp="3synd6pyd9oov" />
                  Access in 5 minutes
                </li>
                <li className="flex items-center gap-1.5" data-id="element-211" data-mp="3k7eok7245o3l">
                  <ShieldCheckIcon className="h-4 w-4 text-gold-deep" aria-hidden="true" data-id="element-212" data-mp="3k4sfu43hl2js" />
                  7-day guarantee
                </li>
              </ul>
            </div>
          </div>
        </div>

        <p className="mt-4 text-center text-xs text-ink-muted" data-id="element-213" data-mp="1ygpvu39qk4xx">
          Price in USD. You&apos;ll be charged the equivalent in your local
          currency.
        </p>
      </div>
    </section>;
}